import type { UserProfileJSONObject } from '@ikegps/core-api';
import { Services } from '../services';

export class UserProfileStore {
	get(userId: string): UserProfileJSONObject | null {
		const rest = Services.Department.rest;
		return rest.Department.User.getProfileById(userId).value;
	}
}
